import React from "react";
import panelStyles from "../../styles/Panel.module.css";
import analyticsStyles from "../../styles/Analytics.module.css";

export function AnalyticsHelpBlock() {
  return (
    <div className={analyticsStyles.block}>
      <h3>Как читать аналитику</h3>
      <div className={panelStyles.note}>
        Этот блок — короткая “инструкция” для модераторов: что означают цифры и как они считаются.
      </div>

      <details>
        <summary>Окна и периоды</summary>
        <ul className={analyticsStyles.list}>
          <li><b>День / Неделя / Месяц</b> в “Воронке новых пользователей” — это когорты по дате регистрации (а не последние 24ч/7д/30д событий).</li>
          <li><b>Последние 24 часа</b> в “Операционном дашборде” — события за реальный скользящий интервал.</li>
          <li><b>Недельные блоки</b> (в разделе “Обзор”) — агрегаты за последнюю неделю.</li>
        </ul>
      </details>

      <details>
        <summary>Термины и события</summary>
        <ul className={analyticsStyles.list}>
          <li><b>Новая регистрация</b> — пользователь с датой регистрации внутри выбранного окна.</li>
          <li><b>Подписка на группу</b> — наличие события <code>group_join</code> у нового пользователя.</li>
          <li><b>Активация</b> — пользователь сделал минимум 1 запрос (1+ сообщений/обращений к боту).</li>
          <li><b>Aha</b> — “ощутил ценность”: порог активности (обычно по токенам/запросам за 24ч).</li>
          <li><b>Paywall</b> — просмотр тарифов/экрана оплаты (<code>paywall_view</code>).</li>
          <li><b>Checkout</b> — переход к оплате (<code>checkout_open</code>).</li>
          <li><b>Покупка</b> — событие <code>purchase</code> (подписка или разовая покупка).</li>
          <li><b>payment_fail</b> — неуспешная попытка оплаты (в “отмены” не считается).</li>
        </ul>
      </details>

      <details>
        <summary>Конверсии (CR) — как считаются</summary>
        <ul className={analyticsStyles.list}>
          <li><b>CR</b> — это доля: <code>числитель / знаменатель</code>, обычно показывается в процентах.</li>
          <li><b>CR paywall→purchase</b> — покупатели / пользователи, просмотревшие paywall.</li>
          <li><b>CR checkout→purchase</b> — покупатели / пользователи, открывшие checkout.</li>
          <li><b>CR Aha→purchase</b> — покупатели / пользователи, достигшие Aha.</li>
        </ul>
      </details>

      <details>
        <summary>Деньги и выручка</summary>
        <ul className={analyticsStyles.list}>
          <li><b>Выручка</b> — сумма <code>amount</code> всех покупок за период.</li>
          <li><b>ARPPU (платные)</b> — выручка по <code>amount &gt; 0</code> / уникальные платящие пользователи (<code>amount &gt; 0</code>).</li>
          <li><b>Средний чек</b> — выручка / количество покупок.</li>
          <li><b>Маржа</b> — (выручка − себестоимость токенов) / выручка.</li>
        </ul>
      </details>

      <details>
        <summary>Подписки: источники и статус</summary>
        <ul className={analyticsStyles.list}>
          <li><b>Платные активные</b> — подтверждённые источники оплаты (например: <code>payment</code>, <code>vkdonut</code>, <code>cloudpayments</code>, <code>tochka</code>).</li>
          <li><b>Подарочные</b> — бесплатные выдачи (ручные, рулетка, промо). Их важно смотреть отдельно, чтобы не завышать KPI.</li>
          <li><b>Legacy (unknown_legacy)</b> — старые/неопределённые подписки. Они показываются отдельно и <b>не включаются</b> в платные KPI, конверсию и LTV.</li>
          <li><b>Неизвестно</b> — случаи, где источник не удалось определить. Это повод разметить <code>subscription_source</code>.</li>
          <li><b>Оплата родителями</b> — <code>purchase</code> с <code>payment_source=parent_payment</code>: учитывается в выручке, но выделяется отдельной строкой.</li>
        </ul>
      </details>

      <details>
        <summary>Retention / удержание</summary>
        <ul className={analyticsStyles.list}>
          <li><b>Удержание D1/D7/D30</b> — доля пользователей, активных на 1/7/30 день после регистрации.</li>
          <li><b>Когорты</b> — пользователи, сгруппированные по неделе регистрации; удобно смотреть “качество” трафика и динамику.</li>
        </ul>
      </details>
    </div>
  );
}

export default AnalyticsHelpBlock;
